module.exports = __webpack_public_path__ + "img/12.ef11a07d.png";